<template>
  <v-menu
    v-model="menu"
    min-width="260px"
    max-width="260px"
    :close-on-content-click="false"
    content-class="UXDatapicker"
    :disabled="sendDisable"
  >
    <template v-slot:activator="{ on }">
      <div class="UXdateInput" v-on="on" style="min-width: 120px">
        <span class="inpTxt pl-1">{{ picker || startDate || today }}</span>
        <i class="UXicon-calendar" :class="{disabled: sendDisable}"></i>
      </div>
    </template>
    <div class="viewPicker month">
      <div class="pickerHead month">
        {{ viewPicker }}
      </div>
      <v-date-picker
        class="schedulePicker day"
        locale="jp"
        v-model="picker"
        full-width
        no-title
        show-current="false"
        @change="menu = false"
        :day-format="getDayFormat"
        :header-date-format="getMonthFormat"
        :disabled="sendDisable"
        :initDay="initDay"
        :min="today"
      ></v-date-picker>
    </div>
  </v-menu>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DateOneDayPickerAll',
  props: ['sendDisable', 'startDate'],
  data () {
    return {
      menu: false,
      picker: this.startDate || moment().format('YYYY-MM-DD'), // startDate 사용 또는 기본값
      viewPicker: moment(this.startDate || new Date()).format('YYYY年 MM月 DD日'), // 초기값
      today: moment().format('YYYY-MM-DD')
    }
  },
  watch: {
    menu () {
      this.$emit('show', this.menu)
    },
    picker () {
      this.$emit('dateUpdate', this.picker)
    },
    startDate (newStartDate) {
      // startDate가 업데이트되면 picker와 viewPicker 동기화
      this.picker = newStartDate || this.today
      this.viewPicker = moment(newStartDate || new Date()).format('YYYY年 MM月 DD日')
    }
  },
  methods: {
    getMonthFormat (date) {
      if (!date.includes('-')) {
        // date가 YYYY 형식인 경우
        return `${date}` // 그냥 YYYY만 반환
      }
      let dateArr = date.split('-')
      return `${dateArr[0]}.${dateArr[1]}`
    },
    getDayFormat (date) {
      return moment(date).format('YYYY-MM-D').split('-')[2]
    },
    initDay () {
      this.picker = ''
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DateOneDayPickerEndType.vue